// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1Gz2W","file":"styles_file__V-LkK"};